export var OUTBOUND_TYPE;
(function (OUTBOUND_TYPE) {
    OUTBOUND_TYPE["\uCD9C\uACE0"] = "\uCD9C\uACE0";
    OUTBOUND_TYPE["\uC7AC\uACE0\uC774\uB3D9"] = "\uC7AC\uACE0\uC774\uB3D9";
})(OUTBOUND_TYPE || (OUTBOUND_TYPE = {}));
